<template>
  <div class="updatePassword">
    <el-form ref="passwordFrom" :model="passwordFrom" :rules="passwordFromRules" label-width="150px">
      <el-form-item label="登录密码" prop="oldPass">
        <el-input v-model="passwordFrom.oldPass"></el-input>
      </el-form-item>
      <el-form-item label="新手机号" prop="phone">
        <div style="position:relative;width: 400px">
          <el-input v-model="passwordFrom.phone"></el-input>
          <el-button type="primary" style="position:absolute;right: 0">发送验证码</el-button>
        </div>
      </el-form-item>
      <el-form-item label="手机验证码" prop="numberCode">
        <el-input v-model="passwordFrom.numberCode"></el-input>
      </el-form-item>
    </el-form>
    <div class="action">
      <el-button type="primary" @click="sendUpdate">提 交</el-button>
    </div>
  </div>
</template>

<script>
import { post } from "../../../utils/request";

export default {
  name: "updatePassword",
  data () {
    return {
      passwordFrom: {},
      passwordFromRules: {
        oldPass: [
          { required: true, message: '请上输入登录密码！', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入新手机号码！', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, required: true, message: '请上正确的手机号码', trigger: 'change' }
        ],
        numberCode: [
          { required: true, message: '请确认手机验证码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    sendUpdate () {
      this.$refs.passwordFrom.validate(v => {
        if (v) {
          post('/gateway/member/updatePhone', this.passwordFrom).then(res => {
            if (res.code === 0) {
              this.passwordFrom = {}
              this.$refs.passwordFrom.resetFields()
              this.$message.success("修改成功！")
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.updatePassword {
  border: 1px solid #cecece;
  padding-top: 30px;
}

.action {
  display: flex;
  justify-content: center;
  margin-top: 120px;
  padding-bottom: 40px;

  ::v-deep .el-button--primary {
    border-radius: 26px;
  }
}

::v-deep .el-form-item__label {
  font-size: 20px !important;
}

::v-deep .el-input__inner {
  width: 400px !important;
}

::v-deep .el-message {
  position: relative;
  z-index: 999999999 !important;
}
</style>
